"use client";

import { z } from "zod";
import { Comment, formSchema } from "./commentForm";
import { Enum_Comment_Commentstatus } from "@/types/generated";
import { CommentItem } from "./commentItem";
import { Button } from "@/components/ui/button";

// Comment List Component
export interface CommentListProps {
  comments: Comment[];
  token: string | null;
  user: any;
  viewAll: boolean;
  setViewAll: (value: boolean) => void;
  onReply: (commentId: string) => void;
  onSubmitReply: (data: z.infer<typeof formSchema>) => Promise<void>;
  replyingTo: string | null;
  cancelReply: () => void;
  level: number;
}

export function CommentList({
  comments,
  token,
  user,
  viewAll,
  setViewAll,
  onReply,
  onSubmitReply,
  replyingTo,
  cancelReply,
  level,
}: CommentListProps) {
  const visibleComments = comments.filter(
    (comment) =>
      !comment.parentComment &&
      (comment.commentStatus === Enum_Comment_Commentstatus.Published ||
        (token && user?.documentId === comment.approvedBy.documentId))
  );

  return (
    <div className="space-y-4">
      {(viewAll ? visibleComments : visibleComments.slice(0, 3)).map(
        (comment) => (
          <CommentItem
            level={level}
            key={comment.documentId}
            comment={comment}
            token={token}
            user={user}
            onReply={onReply}
            onSubmitReply={onSubmitReply}
            replyingTo={replyingTo}
            cancelReply={cancelReply}
          />
        )
      )}

      {visibleComments.length > 3 && !viewAll && (
        <Button
          variant="ghost"
          className="w-full"
          onClick={() => setViewAll(true)}
        >
          Show more comments ({visibleComments.length - 3} hidden)
        </Button>
      )}
    </div>
  );
}
